/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react';
import Link from 'next/link';
import { SubHeading, TextBody } from 'components/Typography/General';

export default function filter_data(props) {
  const { fullWidth, checkedData, slug } = props;
  const [show, setShow] = useState(true);
  function createStarsElement(number) {
    var elements = [];
    for (let i = 0; i < number; i++) {
      elements.push(<i className="bi-star-fill text-primary"> </i>);
    }
    return elements;
  }

  return (
    <div className={`filter-box border ${fullWidth ? '' : 'max-width-297'}  mt-4`} id="duration">
      <SubHeading variety={5}>
        {props.title}{' '}
        <i
          className={`bi p-2 ${show ? 'bi-chevron-up' : 'bi-chevron-down'} display-right font-size-12 cursor-pointer`}
          onClick={() => setShow(!show)}
        />
      </SubHeading>
      {show ? (
        <div className="mt-5">
          {props.data
            ? props.data.map((data, index) => {
                return (
                  <div className="display-flex mt-4" key={index}>
                    {props.title == 'Ratings' ? (
                      <>
                        <input type="checkbox" className="input-checkbox" onChange={() => props.handleFilter('e')} />
                        <span className="margin-left-20 font-size-14">
                          {createStarsElement(Number(data.id))} {data.name}
                        </span>
                      </>
                    ) : (
                      <>
                        <input
                          type="checkbox"
                          className="input-checkbox"
                          checked={checkedData.includes(
                            props.title === 'Course Type' || props.title === 'Language' ? data.name : data.id
                          )}
                          onChange={() =>
                            props.handleFilter(
                              props.title === 'Course Type' || props.title === 'Language' ? data.name : data.id
                            )
                          }
                        />
                        <TextBody tag="span" variety={5} className="margin-left-20">
                          {' '}
                          {data.name} ({data.count})
                        </TextBody>
                      </>
                    )}
                  </div>
                );
              })
            : ''}
          {slug && slug.provider && slug.provider !== 'all' ? (
            <div className="category-show-all-filter mt-4 cursor-pointer">
              <Link href={`/category?provider=all`}>Show All Providers</Link>
            </div>
          ) : (
            ''
          )}
          {/* <p className="mt-4 font-size-14 text-primary font-weight-500">Show More</p> */}
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
